import { render, staticRenderFns } from "./TitleWithSubheading.vue?vue&type=template&id=30cc1e34&functional=true&"
import script from "./TitleWithSubheading.vue?vue&type=script&lang=ts&"
export * from "./TitleWithSubheading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports